export default __webpack_public_path__ + "static/media/payment-method-mobile.78d05734.svg";